module.exports = __webpack_public_path__ + "img/s.b066d2f5.png";